import type { ComponentConfig } from "@puckeditor/core"
import { SectionBase, sectionStyle } from "../lib/section"

export type ImageProps = SectionBase & {
  src: string
  alt: string
  caption: string
  /** "inline" | "wide" | "full-bleed" */
  width: "inline" | "wide" | "full"
  aspectRatio: "auto" | "16/9" | "4/3" | "1/1"
}

export const Image: ComponentConfig<ImageProps> = {
  fields: {
    src: { type: "text", label: "Image URL", contentEditable: true },
    alt: { type: "text", label: "Alt text", contentEditable: true },
    caption: { type: "text", contentEditable: true },
    width: {
      type: "radio",
      options: [
        { value: "inline", label: "Inline" },
        { value: "wide", label: "Wide" },
        { value: "full", label: "Full bleed" },
      ],
    },
    aspectRatio: {
      type: "radio",
      options: [
        { value: "auto", label: "Auto" },
        { value: "16/9", label: "16:9" },
        { value: "4/3", label: "4:3" },
        { value: "1/1", label: "Square" },
      ],
    },
    background: {
      type: "radio",
      options: [
        { value: "none", label: "Transparent" },
        { value: "muted", label: "Muted" },
        { value: "accent", label: "Dark" },
      ],
    },
    paddingY: {
      type: "radio",
      options: [
        { value: "none", label: "None" },
        { value: "sm", label: "Small" },
        { value: "md", label: "Medium" },
        { value: "lg", label: "Large" },
      ],
    },
  },

  defaultProps: {
    src: "",
    alt: "",
    caption: "",
    width: "inline",
    aspectRatio: "16/9",
    background: "none",
    paddingY: "md",
  },

  render: ({ src, alt, caption, width, aspectRatio, background, paddingY }) => {
    const s = sectionStyle({ background, paddingY })
    const maxWidth = width === "inline" ? 800 : width === "wide" ? 1200 : undefined

    return (
      <section style={s}>
        <figure style={{ margin: 0, ...(width === "full" ? {} : { maxWidth, margin: "0 auto", padding: "0 24px" }) }}>
          {src ? (
            <img
              src={src}
              alt={alt}
              style={{
                width: "100%",
                display: "block",
                borderRadius: width === "full" ? 0 : 12,
                ...(aspectRatio === "auto" ? {} : { aspectRatio, objectFit: "cover" as const }),
              }}
            />
          ) : (
            <div
              style={{
                width: "100%",
                aspectRatio: aspectRatio === "auto" ? "16/9" : aspectRatio,
                background: "#f3f4f6",
                borderRadius: width === "full" ? 0 : 12,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#9ca3af",
                fontSize: 14,
              }}
            >
              Image
            </div>
          )}
          {caption && (
            <figcaption style={{ textAlign: "center", marginTop: 12, fontSize: 14, color: "#6b7280" }}>{caption}</figcaption>
          )}
        </figure>
      </section>
    )
  },
}
